import { useFormContext } from '@calendly/form';
import classNames from 'classnames';
import { forwardRef } from 'react';
const limitDescriptionCss = "l1nuc445";
export const LimitDescription = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(limitDescriptionCss, props.className)} />;
});
export const usePullCalendarsLimit = (kind, fieldName) => {
  const {
    values
  } = useFormContext();
  const activeSubCalendarIds = values[fieldName];
  const isLimited = kind === 'outlook';
  const maxSubCalendars = 4;
  const isFieldDisabled = calendarId => isLimited && activeSubCalendarIds.length >= maxSubCalendars && !activeSubCalendarIds.includes(calendarId);
  return [isLimited, isFieldDisabled, maxSubCalendars];
};

require("./use_pull_calendars_limit.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./use_pull_calendars_limit.js");